let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFc4C")).then(() => parcelRequire('klna5'));